import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'contentDuration',
})
export class ContentDurationPipe implements PipeTransform {
    transform(
        duration: number | string | null | undefined,
        format: 'short' | 'long' = 'short',
    ): string {
        const val = typeof duration === 'string' ? parseInt(duration, 10) : (duration ?? 0);

        if (!val || val < 0 || isNaN(val)) {
            return '0s';
        }

        const isShortFormat = format === 'short';
        const secondsStr = isShortFormat ? 's' : ' seconds';
        const minutesStr = isShortFormat ? 'mins' : ' minutes';
        const hoursStr = isShortFormat ? 'hr' : ' hours';

        const hours = Math.floor(val / 3600);
        const minutes = Math.floor((val % 3600) / 60);
        const seconds = Math.floor(val % 60);

        const parts: string[] = [];

        if (hours > 0) {
            parts.push(`${hours}${hoursStr}${hours > 1 ? secondsStr : ''}`);
        }

        if (minutes > 0) {
            parts.push(`${minutes}${minutesStr}${minutes > 1 ? minutesStr : ''}`);
        }

        if (seconds > 0 || parts.length === 0) {
            parts.push(`${seconds} ${secondsStr}`);
        }

        return parts.join(' ');
    }
}
